<template>
  <el-dialog
    title="Criar Diretório"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="isLoading"
    @open="reset"
    width="35%"
  >
    <el-form ref="form" :model="formulario" :rules="validacao" hide-required-asterisk :show-message="false" size="small" label-position="top">
      <el-form-item label="Nome Diretório" prop="nome">
        <el-input v-model="formulario.nome"/>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="validar()" type="primary" size="small" round class="btn-box-shadow">Criar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },

  data() {
    return {
      formulario: {
        nome: "",
      },

      validacao: {
        nome: [{ required: true }],
      },
    };
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    // VENDA
    ...mapState("vendasImoveisStore", {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasContratosStore", {
      venda(state) { return state.vendaSelecionada; }
    }),
    // ALUGUEL
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; }
    }),
    ...mapState("alugueisImoveisStore", {
      imovelAluguel(state) { return state.imovelSelecionado; }
    }),
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    // VENDA
    ...mapActions("vendasImoveisStore", ["criarDiretorioImovel"]),
    ...mapActions("vendasContratosStore", ["criarDiretorioVenda"]),
    // ALUGUEL
    ...mapActions("alugueisContratosStore", ["criarDiretorioAluguel"]),
    ...mapActions("alugueisImoveisStore", {criarDiretorioImovelAluguel: "criarDiretorioImovel"}),

    validar() {
      this.$refs.form.validate(isValid => {
        if(!isValid) {
          this.$alert('Preencha Todos os Campos Obrigatórios', 'Atenção', { confirmButtonText: 'OK' });
          return;
        }

        this.criarDiretorio();
      });
    },

    criarDiretorio() {
      switch(this.tipo) {
      case "ALUGUEL":
        this.requestAluguel();
        break;
      case "VENDA":
        this.requestVenda();
        break;
      case "IMOVEL_VENDA":
        this.requestImovel();
        break;
      case "IMOVEL_ALUGUEL":
        this.requestImovelAluguel();
        break;
      }
    },
    requestImovel() {
      let payload = {
        idObjeto: this.imovel.id,
        tipoFormularios: this.tipo,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioImovel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    requestVenda() {
      let payload = {
        idObjeto: this.venda.id,
        tipoFormularios: this.tipo,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioVenda(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },

    // ALUGUEL
    requestAluguel() {
      let payload = {
        idObjeto: this.aluguel.id,
        tipoFormularios: this.tipo,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioAluguel(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    requestImovelAluguel() {
      let payload = {
        idObjeto: this.imovelAluguel.id,
        tipoFormularios: this.tipo,
        nome: this.formulario.nome
      };

      this.showLoading();
      this.criarDiretorioImovelAluguel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    reset() {
      this.formulario = {
        nome: ""
      };
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

